<template>
  <content-container>
    <div class="user-manual-wrapper">
      <transition name="fade" mode="out-in">
        <loader-with-message v-if="dataLoading"
                             :key="'loadernbainstructions'"
                             :has-error="dataFetchError"
                             @retry="getUserManual"/>
      </transition>
      <bottom-modal size="full"
                    :visible="modalVisible"
                    @modal-close="goBack">
        <div class="user-manual-data sidebar-modal" v-bar="{preventParentScroll: true, scrollThrottle: 15, scrollingPhantomDelay: 200}">
          <div>
            <div v-if="Object.keys(userManualData).length && userManualData.video" class="video-container" :key="'video'+userManualData.video.Title">
              <iframe v-if="userManualData.video.VideoType === 'youtube'"
                      width="100%"
                      height="346" :src="userManualData.video.VideoUrl"
                      :title="userManualData.video.title"
                      frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"></iframe>
              <video v-else width="100%" height="346">
                <!-- treba da vidimo ovde da li može neki drugi video slučajno, ne samo YT -->
                <source :src="userManualData.video.VideoUrl">
              </video>
            </div>
            <div class="data-wrapper" :key="userManualData.title">
              <h3>{{ userManualData.title }}</h3>
              <p class="description" v-html="userManualData.longDescription"></p>
            </div>
            <div class="app-links" key="app-links">
              <a v-if="userManualData.appStoreUrl" :href="userManualData.appStoreUrl" target="_blank" rel="nofollow">
                <img class="store-button" src="/assets/images/app-store-badge.png" alt="app-store">
              </a>
              <a v-if="userManualData.googlePlayUrl" :href="userManualData.googlePlayUrl" target="_blank" rel="nofollow">
                <img class="store-button" src="/assets/images/google-play-badge.png" alt="google-play">
              </a>
              <a v-if="userManualData.webLink" :href="userManualData.webLink" target="_blank" rel="nofollow">
                <img class="store-button" src="/assets/images/check-on-web.png" alt="check-on-web">
              </a>
            </div>
          </div>
        </div>
      </bottom-modal>
    </div>
  </content-container>
</template>
<script>
import BottomModal from '@/components/common/modal/bottom-modal'
import LoaderWithMessage from '@/components/common/loader-with-message'
import ContentContainer from '@/components/common/main-layout/content-container'

export default {
  name: 'user-manual',
  components: { ContentContainer, LoaderWithMessage, BottomModal },
  props: {
    serviceType: {
      type: String
    }
  },
  data () {
    return {
      userManualData: {},
      modalVisible: false,
      dataLoading: true,
      dataFetchError: false
    }
  },
  computed: {
    mainService () {
      if (this.serviceType === 'nba_instructions') {
        return 'nba'
      } else if (this.serviceType === 'hbo_instructions') {
        return 'hbo'
      } else if (this.serviceType === 'deezer_instructions') {
        return 'deezer'
      } else if (this.serviceType === 'move_instructions') {
        return 'move'
      } else if (this.serviceType === 'arena_cloud_instructions') {
        return 'arena'
      } else if (this.serviceType === 'apollon_instructions') {
        return 'apollon'
      } else {
        return ''
      }
    }
  },
  methods: {
    goBack () {
      this.modalVisible = false
      setTimeout(() => {
        this.$emit('open-page', { name: this.mainService.toUpperCase() })
      }, 0)
    },
    getUserManual () {
      this.dataLoading = true
      this.dataFetchError = false
      this.$apiRequest.get(`instructions/${this.mainService}`)
        .then(response => {
          this.userManualData = response.data
          this.modalVisible = true
          this.dataLoading = false
        })
        .catch(e => {
          this.dataFetchError = true
        })
        .finally(() => {
          this.dataLoading = false
        })
    }
  },
  mounted () {
    this.getUserManual()
  }
}
</script>

<style scoped lang="scss" src="./styles/user-manual.scss"></style>
